import type { JSX } from 'solid-js'
import { createSignal } from 'solid-js'
import { UploadCloud } from 'lucide-solid'

export const FileDropzone = (props: {
  accept?: string
  multiple?: boolean
  onFiles: (files: File[]) => void
  disabled?: boolean
  maxSizeBytes?: number
  hint?: string
}): JSX.Element => {
  const [isDrag, setIsDrag] = createSignal(false)
  const [error, setError] = createSignal<string | null>(null)
  // eslint-disable-next-line no-unassigned-vars -- assigned by Solid via ref={inputEl}
  let inputEl: HTMLInputElement | undefined

  const handle = (files: FileList | null) => {
    if (!files) return
    const arr = Array.from(files)
    if (props.maxSizeBytes) {
      const tooBig = arr.find((f) => f.size > props.maxSizeBytes!)
      if (tooBig) { setError(`File "${tooBig.name}" troppo grande (max ${Math.round(props.maxSizeBytes! / 1024 / 1024)}MB)`); return }
    }
    setError(null)
    props.onFiles(arr)
  }

  return (
    <div class="flex flex-col gap-2">
      <div
        data-drag={isDrag()}
        onDragOver={(e) => { e.preventDefault(); setIsDrag(true) }}
        onDragLeave={() => setIsDrag(false)}
        onDrop={(e) => { e.preventDefault(); setIsDrag(false); handle(e.dataTransfer?.files ?? null) }}
        onClick={() => inputEl?.click()}
        class={
          'border-2 border-dashed border-border rounded-lg p-6 text-center cursor-pointer ' +
          'data-[drag=true]:border-accent data-[drag=true]:bg-accent-soft ' +
          'hover:border-border-strong transition-colors'
        }
      >
        <UploadCloud size={32} class="mx-auto text-muted mb-2" />
        <p class="text-sm font-medium text-fg">Trascina qui o <span class="text-accent-strong underline">sfoglia</span></p>
        {props.hint && <p class="text-xs text-muted mt-1">{props.hint}</p>}
        <input
          ref={inputEl}
          type="file"
          accept={props.accept}
          multiple={props.multiple}
          disabled={props.disabled}
          class="sr-only"
          onChange={(e) => handle(e.currentTarget.files)}
        />
      </div>
      {error() && <p role="alert" class="text-xs text-danger">{error()}</p>}
    </div>
  )
}
